package com.eladfinish.bible.contest.screens.americanQuestions.model

// Represents the result of a question that has already been answered.
sealed interface QuestionResult {
    data object Unanswered : QuestionResult
    data object Correct : QuestionResult
    data object Incorrect : QuestionResult
}
